import React from "react"
import types from "prop-types"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import { sectionShape } from "utils/propTypeShapes"
import { SectionBranchingConditionalCheck, SectionContainer } from "shared/form"
import AnsweredFormOverviewQuestions from "./AnsweredFormOverviewQuestions"

const AnsweredFormOverviewSection = ({ isFirstSection, section }) => {
  const { description, name, questions } = section

  const { answers } = useAnsweredFormOverviewContext()

  return (
    <SectionBranchingConditionalCheck
      isFirstSection={isFirstSection}
      formAnswers={answers}
      section={section}
    >
      <SectionContainer description={description} name={name}>
        <AnsweredFormOverviewQuestions questions={questions} />
      </SectionContainer>
    </SectionBranchingConditionalCheck>
  )
}

AnsweredFormOverviewSection.propTypes = {
  isFirstSection: types.bool.isRequired,
  section: sectionShape.isRequired,
}

export default AnsweredFormOverviewSection
